import * as api from "@/api/stationAutoDj.api"

const STORAGE_REFRESH_DELAY = 1500

let autoDjRequest = 0
let storageRefreshTimer = null
let storageRequest = 0

export const fetchAutoDj = async ({ commit }, stationKey) => {
  const request = ++autoDjRequest
  const autoDj = await api.getAutoDj(stationKey)

  if (request === autoDjRequest) {
    commit("setAutoDj", autoDj)
    commit("setStationKey", stationKey)
  }
}

// The storage total is only returned by GET auto_dj, so it is re-read after uploads and deletes. Debounced so
// a batch of uploads finishing one after another costs one request. Only storageUsedBytes is taken from the
// response: setAutoDj would also replace the playlist and overwrite an unsaved reorder.
export const refreshStorageUsage = ({ commit, state }, stationKey) => {
  clearTimeout(storageRefreshTimer)

  storageRefreshTimer = setTimeout(async () => {
    const request = ++storageRequest

    try {
      const autoDj = await api.getAutoDj(stationKey)

      if (request === storageRequest && state.stationKey === stationKey && typeof autoDj?.storageUsedBytes === "number") {
        commit("setStorageUsedBytes", autoDj.storageUsedBytes)
      }
    } catch (e) {
      // The figure just stays as it was; the next refresh or page load corrects it.
      console.error("Error refreshing AutoDJ storage usage:", e)
    }
  }, STORAGE_REFRESH_DELAY)
}

export const reorderPlaylist = async ({ commit, state }, { stationKey, references }) => {
  await api.updatePlaylistTracksOrder(stationKey, references)

  if (state.stationKey === stationKey) {
    commit("setPlaylist", references)
  }
}

export const changePreviewURL = async ({ commit }, url) => {
  commit("setPreviewURL", url)
}

export const shufflePlaylist = async ({ commit, state }, { stationKey, shuffle }) => {
  await api.updatePlaylistShuffle(stationKey, shuffle)

  if (state.stationKey === stationKey) {
    commit("setShuffle", shuffle)
  }
}

export const fetchCurrentlyPlaying = async ({ commit, state }, stationKey) => {
  const current = await api.getCurrentlyPlaying(stationKey)

  if (state.stationKey === stationKey) {
    commit("setCurrent", current)
  }
}

export const deleteTracks = async (vuex, { stationKey, references }) => {
  await api.deletePlaylistTracks(stationKey, references)

  if (vuex.state.stationKey !== stationKey) {
    return
  }

  const playlist = vuex.state.autoDj.playlist.filter((reference) => !references.includes(reference))

  vuex.commit("setPlaylist", playlist)
  vuex.dispatch("refreshStorageUsage", stationKey)
}

export const addPlaylistReferences = async ({ state, commit }, references) => {
  commit("setPlaylist", state.autoDj.playlist.concat(references))
}
